import { Icon } from "../icons/Icon";

const Required = () => {
  return (
    <Icon name="asterisk" className="size-2 text-ib-pt-color-red-800 ml-0.5" />
  );
};

export default Required;
